import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import UnreadNotificationsBubble from 'Dashboard/components/UnreadNotificationsBubble/UnreadNotificationsBubble';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';
import WpBadge from 'Wpds/components/badge/WpBadge';
import ContextMenuWrapper from '../ContextMenuWrapper/ContextMenuWrapper';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

import './TeamItem.scss';

type Props = {
  displayName: string;
  isPersonal: boolean;
  displayAvatar: {
    color: string;
    initials: string;
    profilePictureUrl: string;
  };
  path: string;
  isNotInvited: boolean;
  isInvitePending: boolean;
  showNewBadge: boolean;
  notificationsCount: number;
  onCloseNavbar: Function;
  workspaceId: string;
  starred: boolean;
};

function TeamItem({
  workspaceId,
  isPersonal,
  displayName,
  displayAvatar,
  path,
  isNotInvited,
  isInvitePending,
  showNewBadge,
  notificationsCount,
  onCloseNavbar,
  starred,
}: Props) {
  const isExpanded = useContext(ExpandNavbarContext);
  const isCurrentWorkspace = useSelector(state => state.workspace.id === workspaceId);

  return (
    <ContextMenuWrapper workspaceId={workspaceId} starred={starred}>
      <NavLink
        to={`${path}?personal=${isPersonal ? 1 : 0}&is_group=0`}
        className="team-item d-flex nav-link align-items-center my-2"
        activeClassName="active"
        onClick={onCloseNavbar}
      >
        {isExpanded ? (
          <>
            <div className="mr-2">
              <WpAvatar avatar={displayAvatar} size="sm" />
            </div>
            <div className="team-item-name">
              {displayName}
              {isNotInvited && (
                <div className="team-item-not-invited text-warning">
                  <i>(not invited yet)</i>
                </div>
              )}
              {isInvitePending && (
                <div className="team-item-invite-pending text-muted">
                  <i>(Invite pending)</i>
                </div>
              )}
            </div>
            <div className="ml-auto d-flex align-items-center">
              {!showNewBadge && notificationsCount && !isCurrentWorkspace ? (
                <UnreadNotificationsBubble count={notificationsCount} classNames="mr-1" />
              ) : null}
              {showNewBadge && (
                <span className="mr-1">
                  <WpBadge color="green">New</WpBadge>
                </span>
              )}
            </div>
          </>
        ) : (
          <WpTooltip placement="right">
            <div className="team-item--expanded">
              <WpTooltipTrigger>
                <div className={cn('position-relative', { 'team-item-avatar-notify': notificationsCount })}>
                  <WpAvatar avatar={displayAvatar} size="sm" />
                </div>
              </WpTooltipTrigger>
              <WpTooltipContent>{displayName}</WpTooltipContent>
            </div>
          </WpTooltip>
        )}
      </NavLink>
    </ContextMenuWrapper>
  );
}

export default TeamItem;
